import React, { useState ,useEffect, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import '../App.css'
import * as R from 'ramda'
import * as api from "../api/apiFunc";
import ListIcons from '../Components/Lib/ListIcons';

import TextField from '@material-ui/core/TextField';
import SelectDataList  from "./Lib/SelectDataList";

const useStyles = makeStyles( theme => ({    
  root: {
    margin: theme.spacing.unit*2,
    textAlign: 'left',
  },
  textList: {
   marginTop: theme.spacing.unit*0.5,  
   color : '#000',
   backgroundColor: '#fff',
   width: '100%',
   height: '75%',
   fontSize: '85%',
   borderWidth: 1,
   borderColor: '#fff',
   borderStyle: 'solid',
   borderRadius: '3%',
   boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.25);'
},
textListNew: {
   marginTop: -theme.spacing.unit,    
   marginBottom: theme.spacing.unit*1,    
   color : 'gold',
   width: '95%',
   hight: '70%',
   fontSize: '80%',
},
textListNewSmall: {
   marginTop: -theme.spacing.unit,    
   marginBottom: theme.spacing.unit*1,    
   color : 'red',
   width: '95%',
   hight: '70%',
   fontSize: '80%',
},
textListNm: {
   marginTop: theme.spacing.unit*0.5,    
   //marginLeft: theme.spacing.unit*0.1,    
   color : 'green',
   width: '65%',
   fontSize: '90%',
   borderWidth: 1,
   borderColor: '#ffaad5',
   borderStyle: 'solid',
   borderRadius: '5%'
},
textField: {
   width: '100%',
   //height: '100%',
   height: '2.1476em',
   marginBottom: '6px'
},
textField2: {
   width: '100%',
   height: '100%',
},
input: {
   display: 'flex',
   padding: 0,
   marginTop: 1,
   color : '#000',
   height: '90%',
   backgroundColor: '#fff',
   fontSize: '90%',
   borderWidth: 1,
   borderColor: '#fff',
   borderStyle: 'solid',
   borderRadius: '3%',
   boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.25)'
 },
 valueContainer: {
   display: 'flex',
   flexWrap: 'wrap',
   flex: 1,
   alignItems: 'center',
   overflow: 'hidden',
 },  
}));


const ShowAppSidebar = (props) => {
   
        const classes = useStyles()
        const { config } = props
        const [curBlock, SetCurBlock] = useState([])
        const [iconsApp, SetIconsApp] = useState([])
      
        useEffect(() => {
          if (api.isEmpty(config.configApp)) return
          //console.log('config.configApp',config.configApp);
          SetCurBlock(R.find(R.propEq("block", config.name))(config.configApp)) 
          SetIconsApp(config.iconsApp) 
        }, [config]);
      
        const ComputedAccess = () => {
         const {config,iconsapp} = this.props       
         if (!api.isNotEmptyArr(config.iconsapps)) return {} 
         let access = {}  
         config.iconsapps.map((icon) => {
               const iconapp = R.find(R.propEq('id', icon.id))(iconsapp)
               switch (iconapp.name) {
                   case "apps": access = {...access, [iconapp.name]: 1 }
                   break
               }
         })
         return access  
       }
     
        return(
          <div className="App-left-sidebar">
            <div className="container">
              <h4 style={{position:'absolute',top:'30vh',left:'10vh'}}>SideBar</h4>    
             </div>
             <div>
              {<ListIcons icons={curBlock.icons} iconsapp={iconsApp} access={ComputedAccess} handleOnClick={()=>{}} />}
             </div>
         </div>
        );
}

export default ShowAppSidebar;

